import React from 'react'
import styled from 'styled-components'
import {
    WerfenColor, WerfenFormTextColor,
    White
} from '../../Constants/ColorChart';
import { Col, Modal, Row } from "react-bootstrap";
import Button from "../Button/Button";

const StyledModal = styled( Modal )`
    & .modal-dialog.modal-lg{
        max-width: 1200px;
    }
`

const StyledModalHeader = styled( Modal.Header )`
    & .close{
        border: 0 none transparent;
        font-size: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 15px;
        top: 10px;
        width: 40px;
        height: 40px;
        opacity: 0.5;
        &:hover {
            opacity: 1;
        }
        & .sr-only {
            display: none;
        }
    }
`
const StyledParagraph = styled.p `
    border: none;
	width: 100%;
	color: ${  WerfenFormTextColor };
	padding-left: 5%;
	padding-right: 5%; 
    display: inline-block;
    padding-bottom: 2%;
    margin-right: 0px;
    font-size: 15px;
    text-align: justify;
`
const StyledHeaderSmall =styled.h5 `
 border: none;
	width: 100%;
	color: ${  WerfenFormTextColor };
	padding-left: 5%;
	padding-right: 5%; 
    display: block;
    padding-bottom: 2%,
    margin-right: 0px;
    font-size: 16px;
    text-align: left;
    font-weight: 700
`
const StyledUnorderedList = styled.ul `
    padding-left: 7%;
    color: ${  WerfenFormTextColor };
`;
const StyledListItem = styled.li `
    padding-left: 0;
    width: 100%;
	color: ${  WerfenFormTextColor };
	padding-left: 5%;
	padding-right: 5%; 
    padding-bottom: 2%;
    margin-right: 0px;
    font-size: 15px;
    text-align: justify;
}
`;

const LoginTermsModal = ( { openTermsPopUp, termsPopUpOpen }) => (
    <StyledModal
        show={termsPopUpOpen }
        onHide={ ()=> openTermsPopUp(false) }
        size="lg"
        backdrop="static"
    >
        <StyledModalHeader closeButton className={ "with-close-button" }>
            <Modal.Title>{ "Términos y Condiciones de Servicio" }</Modal.Title>
        </StyledModalHeader>
        <Modal.Body>
            <StyledParagraph>POR FAVOR, LEA ESTOS TÉRMINOS Y CONDICIONES DE SERVICIO (“TÉRMINOS”)
                YA QUE CONTIENEN INFORMACIÓN IMPORTANTE SOBRE SUS DERECHOS, RECURSOS Y OBLIGACIONES LEGALES. </StyledParagraph>
            <StyledParagraph>IL Diagnostics, S.A. de C.V., en adelante "Werfen México”, con domicilio social en Lago Victoria número 80, Colonia Granada, Alcaldía Miguel Hidalgo, C.P. 11520, Ciudad de México y clave de Registro Federal de Contribuyentes IDI911004UC5, le da la bienvenida su sitio web destinado a los integradores, https://integradoresmx.werfen.com/ (“Web”).
                Puede contactar con nosotros en el teléfono 55 52 62 17 60 o en la dirección de correo electrónico comunicacion.mx@werfen.com.
                Werfen México es una compañía perteneciente al grupo Werfen (conjuntamente “Werfen”).
            </StyledParagraph>
            <StyledParagraph>La Web proporciona una plataforma para que los usuarios puedan acceder al repositorio de información interna en la que se comparte toda la documentación necesaria requerida por las entidades públicas y privadas (“Entidades”) promotoras de licitaciones.
                El acceso y su uso requiere su registro previo como miembro de la Web, tal y como se explica con más detalle en la sección “Registro y uso de la Web”.
                La Web está destinada únicamente a usuarios que posean la condición de integradores (“usuarios” o “integradores”, indistintamente) que desarrollen una actividad comercial o profesional.
                Por tanto, al acceder a la Web y hacer uso de la misma, usted garantiza y declara que es un integrador y que es mayor de edad de acuerdo con la legislación aplicable en su jurisdicción.</StyledParagraph>
            <StyledParagraph>Werfen puede revisar, modificar y actualizar estos Términos en cualquier momento. Todos los cambios tendrán efecto inmediato una vez sean actualizados en la Web.
                Por favor, asegúrese que visita y revisa periódicamente estos Términos. El uso continuado de la Web significará que usted acepta la versión vigente de los Términos.
                En el caso de que se realice una modificación sustancial de los Términos, se le pedirá nuevamente que los acepte o, en su caso, que deje de hacer uso de la Web.</StyledParagraph>
            <StyledParagraph>Werfen podrá, en cualquier momento, finalizar o suspender el funcionamiento de la Web.
                Los integradores no podrán hacer valer la indisponibilidad de la Web para eludir sus responsabilidades si la información interna contenida en la misma es compartida con los integradores a través de cualquier otro canal.
                Werfen no se hace responsable y declina todo tipo de responsabilidad en relación con la disponibilidad de forma continuada de la Web.</StyledParagraph>
            <StyledParagraph>Estos Términos se actualizaron por última vez el 31 de enero del 2023.  </StyledParagraph>
            <StyledHeaderSmall>
                Registro y Uso de la Web
            </StyledHeaderSmall>
            <StyledParagraph>
                La Web incluye documentación interna específicamente dirigida a los integradores para su presentación ante las Entidades promotoras de las distintas licitaciones de interés de Werfen México.
            </StyledParagraph>
            <StyledParagraph>
                El acceso a la Web requiere el registro previo como miembro de la web (“Miembro”).
                Los Miembros deberán proporcionar, como mínimo, la siguiente información para crear una cuenta de usuario de Werfen: Nombre de usuario, nombre, apellidos, correo electrónico y contraseña.
                Los Miembros deben notificar cualquier cambio en sus datos personales para asegurar que la información que mantenemos en nuestros sistemas está actualizada.
                En particular, y sin limitación, el usuario deberá asegurar que la dirección de correo electrónico facilitada a Werfen México esté actualizada y sea efectiva para contactar con el usuario.
            </StyledParagraph>
            <StyledParagraph>
                Werfen se reserva el derecho a denegar el registro a cualquier usuario a su entera discreción.
            </StyledParagraph>
            <StyledHeaderSmall>Seguridad de la cuenta</StyledHeaderSmall>
            <StyledParagraph>Usted es responsable de mantener la confidencialidad de su nombre de usuario y de la contraseña que escoja durante el proceso de registro, así como de todas las actividades que se realicen con su nombre de usuario y contraseña.
                Usted deberá comunicarnos inmediatamente cualquier uso no autorizado de su nombre de usuario o contraseña, o de cualquier incidente de seguridad.
                Werfen no será responsable de ninguna pérdida o daño derivado del incumplimiento por su parte con respecto a esta disposición. Deberá tener especial cuidado cuando acceda a su cuenta desde un ordenador público o compartido de modo que otras personas no vean o dispongan de su contraseña o cualquier otra información personal suya.
            </StyledParagraph>
            <StyledHeaderSmall>
                Limitaciones de Uso
            </StyledHeaderSmall>
            <StyledParagraph>
                Werfen le concede un derecho y una licencia personal limitada, no exclusiva e intransferible para acceder a la Web.
                Esta Web, incluyendo entre otros y sin limitación, sus contenidos, metadatos, diseño, organización, compilación, apariencia, artículos, manuales, instrucciones, catálogos, registro, certificados, precios, información en general y,
                cualquier otro contenido disponible a través de la Web (“Material Propio”) son propiedad de Werfen o de nuestros licenciantes y están protegidos por derechos de autor (copyright) y normativa de propiedad intelectual. Werfen se reserva todos los derechos relacionados con el Material Propio.
                A menos que cuente con el consentimiento por escrito de Werfen, no puede copiar, reproducir, vender, publicar, distribuir, mostrar, retransmitir, modificar o proporcionar acceso público de cualquier otra forma al Material Propio al que tiene acceso a través de la Web a nadie, excepto para los usos referidos en el párrafo a continuación.
                Usted acepta no reorganizar, modificar o generar material derivado utilizando nuestro Material Propio.
            </StyledParagraph>
            <StyledParagraph>
                El acceso a la Web lleva implícito el consentimiento de Werfen para usar dicho Material Propio con fines exclusivamente profesionales limitados a aquellos que sean imprescindibles para el desempeño profesional
                de la actividad de los integradores en su tarea de facilitar el acceso a dicho Material a las Entidades promotoras de licitaciones de interés de Werfen México.
            </StyledParagraph>
            <StyledHeaderSmall>Conducta</StyledHeaderSmall>
            <StyledParagraph>
                El usuario se compromete a utilizar la Web y la información que ésta contiene con la debida diligencia y a cumplir íntegramente con la legislación aplicable y los presentes Términos.
            </StyledParagraph>
            <StyledParagraph>
                Werfen México se reserva el derecho a finalizar su estatus de Miembro si hace un uso indebido de la Web o infringe estos Términos que incluyen, entre otras, las siguientes normas de conducta.
            </StyledParagraph>
            <StyledParagraph>
                Usted no podrá:
            </StyledParagraph>
            <StyledUnorderedList>
                <StyledListItem>
                    Utilizar una identidad falsa con el objetivo de inducir a error a Werfen México u otros;
                </StyledListItem>
                <StyledListItem>
                    Suplantar la identidad de otra persona o entidad, incluido otro Miembro o usuario de la Web o empleado de Werfen, o declarar falsamente o tergiversar su relación con una persona o entidad;
                </StyledListItem>
                <StyledListItem>
                    Transmitir a otros Miembros o usuarios de la Web por cualquier medio, o de cualquier otra manera poner a disposición cualquier contenido o material que usted no tenga derecho a divulgar bajo cualquier ley o relación contractual o fiduciaria;
                </StyledListItem>
                <StyledListItem>
                    Transmitir a otros Miembros o usuarios de la Web por cualquier medio, o poner a disposición cualquier contenido o material que infrinja cualquier patente, marca, secreto industrial, derecho de autor (copyright) u otros derechos de propiedad de cualquier parte;
                </StyledListItem>
                <StyledListItem>
                    Remitir a otros Miembros o usuarios de la Web por cualquier medio, o poner a disposición cualquier material que contenga virus o malware, archivos o programas diseñados para interrumpir, destruir o limitar la funcionalidad de cualquier software o hardware informático o equipo de telecomunicaciones;
                </StyledListItem>
                <StyledListItem>
                    Intentar interferir o interrumpir nuestros servidores o redes o los Servicios que se le proporcionan;
                </StyledListItem>
                <StyledListItem>
                    Infringir, intencionadamente o no, cualquier ley o normativa aplicable, que tenga fuerza de ley, local, regional, nacional o internacional.
                </StyledListItem>
                <StyledListItem>
                    Acechar o acosar a otro individuo; solicitar, recopilar o publicar datos personales o intentar solicitar, recopilar o publicar datos personales sobre otros usuarios, incluidos nombres de usuario o contraseñas; o acceder o intentar acceder a la cuenta de otro usuario sin su consentimiento; y/o
                </StyledListItem>
                <StyledListItem>
                    Publicar, propagar, transmitir o distribuir de cualquier modo sus datos personales o datos de su plan en cualquier sitio web o a través de otros medios digitales, electrónicos o impresos.
                </StyledListItem>
            </StyledUnorderedList>
            <StyledHeaderSmall>
                Protección de Datos de carácter Personal
            </StyledHeaderSmall>
            <StyledParagraph>
                Por favor, lea nuestra Política de Privacidad, disponible aquí <a href={"https://werfen.com/mx/es/politica-de-privacidad"} target={"_blank"}>[Política de Privacidad | Werfen en México]</a>, y nuestra Política de Cookies, disponible aquí <a href={"https://werfen.com/es/es/politica-de-cookies"} target={"_blank"}>[Política de Cookies | Werfen en España]</a>, para más información sobre cómo tratamos sus datos personales y aspectos relacionados con los mismos.
            </StyledParagraph>
            <StyledHeaderSmall
            >
                Confidencialidad de la información
            </StyledHeaderSmall>
            <StyledParagraph>
                El usuario se compromete a tratar, por un plazo indefinido, la Información Confidencial contenida en la Web.
            </StyledParagraph>
            <StyledParagraph>
                A los efectos de lo previsto en esta Cláusula, se entenderá por “Información Confidencial” aquella información, oral, escrita o visual, que bien por su naturaleza, bien por estar así expresamente indicado, sea de carácter confidencial
                (incluyendo, entre otras, informaciones de carácter científico, técnico, know-how, secretos industriales, fórmulas, prototipos, protocolos, precios, Marketing,
                operaciones, financiera, legal, fiscal y comercial, modelos y estrategias de negocio, clientes -actuales o potenciales-, proveedores -actuales o potenciales-, proyectos y operaciones de cualquier carácter  propuestas o
                en fase de estudio, informes, proyecciones de mercado y datos, junto con los análisis y documentos de trabajo, recopilaciones, comparaciones, estudios, etc.).
                No será considerada “Información Confidencial” aquella información: (a) ya conocida por los Clientes o terceros receptores de dicha Información;
                o (b) que haya pasado a formar parte del dominio público sin incumplimiento de ninguna obligación de confidencialidad.
            </StyledParagraph>
            <StyledParagraph>
                El usuario se obliga a divulgar la Información Confidencial únicamente para cumplir con los requisitos impuestos por Entidades promotoras de licitaciones, comprometiéndose a trasladarles el carácter confidencial de dicha Información y, por ende, su obligación de mantener en absoluta confidencialidad toda la información que resulte identificada como tal o que por su naturaleza así lo exija, siendo responsables solidarios en caso de que dicha obligación sea violada.
            </StyledParagraph>
            <StyledHeaderSmall>
                Exención de responsabilidades
            </StyledHeaderSmall>
            <StyledParagraph>
                USTED UTILIZA LA WEB BAJO SU PROPIA RESPONSABILIDAD.
                WERFEN RECHAZA EXPRESAMENTE TODAS LAS MANIFESTACIONES Y GARANTÍAS SOBRE LA EXACTITUD, EXHAUSTIVIDAD, TEMPORALIDAD O EFICACIA DE LOS CONTENIDOS DE LA WEB Y
                NO ASUME NINGUNA OBLIGACIÓN O RESPONSABILIDAD SOBRE CUALQUIER ERROR, FALLO O IMPRECISIÓN EN DICHOS CONTENIDOS. USTED ACEPTA QUE SU ACCESO A LA WEB Y
                EL USO DE LOS CONTENIDOS SERÁ "TAL CUAL ESTÁN", "SEGÚN PUESTOS A DISPOSICIÓN" Y, EN CONSECUENCIA, WERFEN NO MANIFIESTA NI GARANTIZA,
                YA SEA DE FORMA EXPRESA O IMPLÍCITA, ENTRE OTRAS, LA IDONEIDAD PARA UNA FINALIDAD CONCRETA Y LA NO INFRACCIÓN.
                WERFEN NO GARANTIZA NI HACE NINGUNA REPRESENTACIÓN SOBRE EL USO O LOS RESULTADOS DEL USO DE LOS MATERIALES DE ESTA WEB. SI CUALQUIER AUTORIDAD PERTINENTE ESTABLECE QUE
                ALGUNA PARTE DE ESTA SECCIÓN NO PUEDE APLICARSE, LA RESPONSABLIDAD DE WERFEN QUEDARÁ LIMITADA AL MÁXIMO GRADO POSIBLE PERMITIDO POR LA LEY APLICABLE.
            </StyledParagraph>
            <StyledHeaderSmall>
                Limitación de responsabilidad
            </StyledHeaderSmall>
            <StyledParagraph>
                USTED RECONOCE Y ACEPTA QUE WERFEN NO SERÁ RESPONSABLE DE NINGÚN DAÑO DIRECTO, INDIRECTO, INCIDENTAL, ESPECIAL, CONSECUENCIAL, EJEMPLAR O PUNITIVO O DE CUALQUIER OTRO TIPO, INCLUIDOS,
                PERO SIN LIMITARSE A ELLO, DAÑOS POR PÉRDIDA DE BENEFICIOS, POR FONDO DE COMERCIO, USO, DATOS U OTRAS PÉRDIDAS INTANGIBLES
                (INCLUSO SI WERFEN HA SIDO INFORMADA DE LA POSIBILIDAD DE DICHOS DAÑOS), QUE SURJAN O RESULTEN DE (A) EL USO O LA INCAPACIDAD DE USAR EL SITIO WEB;
                (B) EL USO DE CUALQUIER CONTENIDO U OTRO MATERIAL DEL SITIO WEB O DE OTROS SITIOS WEB RELACIONADOS CON EL SITIO WEB,;
                (C) ACCESO NO AUTORIZADO O ALTERACIÓN DE SUS TRANSMISIONES O DATOS; (D) DECLARACIONES O CONDUCTA DE CUALQUIER TERCERO EN LA WEB;
                O (E) CUALQUIER OTRO ASUNTO RELACIONADO CON LA WEB.
                EN NINGÚN CASO LA RESPONSABILIDAD TOTAL DE WERFEN POR LOS DAÑOS, PÉRDIDAS Y CAUSAS DE ACCIÓN
                (INDEPENDIENTEMENTE DE SI ES POR CONTRATO, RESPONSABILIDAD CONTRACTUAL INCLUYENDO, PERO SIN LIMITACIÓN, LA NEGLIGENCIA, O DE OTRO TIPO) SUPERARÁ LA CANTIDAD SATISFECHA A WERFEN.
                SI ESTA LIMITACIÓN DE RESPONSABILIDAD FUERA DECLARADA COMO NO ES VÁLIDA, LA RESPONSABILIDAD DE WERFEN SE LIMITARÁ AL GRADO MÁXIMO PERMITIDO POR LA LEY.
            </StyledParagraph>
            <StyledHeaderSmall>
                Enlaces con otros sitios web
            </StyledHeaderSmall>
            <StyledParagraph>
                Puede que utilicemos enlaces a sitios web para su conveniencia. Usted acepta que Werfen no controla esos sitios Web y que, por tanto, no asume ninguna responsabilidad.
                Werfen le anima a que tenga esto en cuenta cuando abandone nuestra Web y que lea atentamente los avisos legales y de privacidad de todos y cada uno de los sitios web que visite.
                El uso que usted haga en un sitio web de un tercero estará sujeto a los términos de uso y política de privacidad de dichos terceros.
                No expresamos ninguna opinión sobre el contenido de otros sitios web o servicios de terceros y por lo tanto Werfen no será responsable por toda la información de terceros ni por su uso.
            </StyledParagraph>
            <StyledHeaderSmall>
                Ley aplicable y elección de foro
            </StyledHeaderSmall>
            <StyledParagraph>
                Usted acepta que estos Términos y Condiciones, así como cualquier y todas las modificaciones surgidas de éstos, se regirán e interpretarán de acuerdo con las leyes mexicanas aplicables, sin tener en cuenta ningún conflicto o elección de principios legales.
            </StyledParagraph>
            <StyledParagraph>
                Por la sola visita o uso de este sitio de Internet, usted se obliga a indemnizar a Werfen México, sus accionistas, directores, empleados y filiales respecto de los daños, perjuicios, penalidades, multas, gastos y costas en que incurran derivados de la violación a estos Términos y Condiciones.
            </StyledParagraph>
            <StyledParagraph>
                Usted acepta que cualquier controversia que se suscite con relación al contenido, interpretación, ejecución y/o extinción de los Términos y Condiciones y/o el uso del Sitio, será resuelta por los Tribunales competentes de la República Mexicana.
            </StyledParagraph>
            <StyledHeaderSmall>
                Términos diversos
            </StyledHeaderSmall>
            <StyledParagraph>
                Werfen puede ceder sus derechos y obligaciones en virtud de estos Términos. Estos Términos redundarán en beneficio de los sucesores, cesionarios y licenciatarios de Werfen.
                El hecho de que cualquiera de las partes no reclame o solicite el cumplimiento estricto de la otra parte con respecto a cualquiera de las disposiciones de estos Términos,
                o ejerza cualquier derecho en virtud de los Términos, no se interpretará como una exención o renuncia en ninguna medida de los derechos de dicha parte de hacer valer o sujetarse a los mismos.
            </StyledParagraph>
            <Row>
                <Col
                    lg={ { span: 2, offset: 10 } }
                    xs={ { span: 10, offset: 1 } }
                >
                    <Button
                        centered
                        miniSized
                        text="Cerrar"
                        background={ WerfenColor }
                        color={ White }
                        onClick={ () => openTermsPopUp(false)} />
                </Col>
            </Row>
        </Modal.Body>
    </StyledModal>
)
export default LoginTermsModal
